import { Icon } from "@material-ui/core";
import Toolbar from "Components/Common/Toolbar/Toolbar";
import RouterLink from "Components/RouterLink/RouterLink";
import { RouterLinkType } from "Enums/RouterLinkType";
import * as React from "react";
import i18n from "Translations/i18n";
import styles from "./ChecklistTemplateBlockOverviewHeader.scss";

const ChecklistTemplateBlockOverviewHeader: React.FunctionComponent<{}> = () => (
    <div className={styles.checklistTemplateOverviewHeader}>
        <Toolbar>
            <RouterLink to="/checklisttemplates/new" type={RouterLinkType.default}>
                <button>
                    <Icon>add</Icon>
                    {i18n.t("checklists.createNewChecklist")}
                </button>
            </RouterLink>
        </Toolbar>
        <h1>{i18n.t("checklists.blockOverviewTitle")}</h1>
    </div>
);

export default ChecklistTemplateBlockOverviewHeader;


// WEBPACK FOOTER //
// ./src/Components/Pages/CheckTemplateBlockOverview/ChecklistTemplateBlockOverviewHeader/ChecklistTemplateBlockOverviewHeader.tsx